import { Button, InputV2, MuiModal } from '@pinchenterprisesnpm/friday-ui'
import { IUpshifterNumberFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/upshifters-number-section/upshifters-number-section.types'
import { connect, FormikProps } from 'formik'
import { useMemo, useState } from 'react'

const { Header, Content, Footer } = MuiModal

interface INumberUpshiftersModalProps {
  isOpen: boolean
  closeModal: () => void
  formik?: FormikProps<IUpshifterNumberFormValues>
}

export const NumberUpshiftersModal = connect<INumberUpshiftersModalProps>(
  ({ isOpen, closeModal, formik }) => {
    const { values, setFieldValue, errors } = formik

    const [numberValue, setNumberValue] = useState<number | ''>(values.positions ?? 1)

    const handleCloseModal = () => {
      closeModal()
      setNumberValue(values.positions ?? 1)
    }

    const errorMessage = useMemo(() => {
      if (typeof numberValue === 'number' && numberValue < 1) {
        return 'The number of Upshifters must be at least one.'
      }
      if (typeof numberValue === 'string' && numberValue === '') {
        return 'The number of Upshifters must be at least one.'
      }
      return undefined
    }, [numberValue])

    return (
      <MuiModal isOpen={isOpen} closeModal={handleCloseModal}>
        <Header title='Number of Upshifters' />

        <Content>
          <InputV2
            labelStyles={{
              color: '#868686',
              fontWeight: 400,
            }}
            leftElementStyles={{
              top: 8,
              left: -1,
            }}
            numberArrowIconColor='gray.400'
            numberArrowsWrapperStyles={{
              right: 3,
            }}
            type='number'
            name='positions'
            id='positions'
            width='500px'
            value={numberValue}
            onChange={(e) => {
              const rawValue = e.target.value
              if (rawValue === '') {
                setNumberValue('')
              } else {
                let val = Number(rawValue)
                if (val < 0) val = 0
                setNumberValue(val)
              }
            }}
            errorMessage={errorMessage}
          />
        </Content>

        <Footer>
          <Button isFilledOutlined onClick={handleCloseModal}>
            Cancel
          </Button>

          <Button
            onClick={() => {
              setFieldValue('positions', numberValue)
              closeModal()
            }}
            isDisabled={!!errorMessage}
          >
            Save
          </Button>
        </Footer>
      </MuiModal>
    )
  }
)
